// Automatically focus on element when it is mounted
// example: <input type="text" v-focus>
const focus = {
    mounted: function (el) {
      setTimeout(function () {
        el.focus()
      }, 500)
    }
}

export default focus;
